import { MutationTree } from 'vuex';
import { AxiosError } from 'axios';
import {
  ActivateOrderResponse, Basket, CheckoutData, OrderState,
} from './types';
import { getDefaultErrorState, getDefaultLoadingState, getDefaultState } from '../utils';
import { MutationRequestStatus } from '../types';

export const mutations: MutationTree<OrderState> = {
  basketLoading: (state) => state.basket = { ...getDefaultLoadingState() },
  basketError: (state) => state.basket = { ...getDefaultErrorState() },
  basketLoaded(state, payload: CheckoutData) {
    payload.basket.preorder = new Date(payload.basket.preorder);

    state.basket = {
      error: undefined,
      status: MutationRequestStatus.SUCCESS,
      data: payload,
    };
  },
  productError(state) {
    state.basket = { ...getDefaultErrorState() };
  },

  activateOrderLoading: (state) => state.order = { ...getDefaultLoadingState() },
  activateOrderLoaded: (state, payload: ActivateOrderResponse) => state.order = {
    error: undefined,
    status: MutationRequestStatus.SUCCESS,
    data: payload,
  },
  // A request that got no response (network error, edge timeout) or a body that is not ours still has
  // to reach step four as an error: throwing here would leave the activation loading forever and stop
  // the checks a pending payment depends on (TV-2176).
  activateOrderError: (state, error: AxiosError) => {
    state.order = {
      ...getDefaultErrorState(),
      error: {
        code: error.response?.status,
        message: error.response?.data?.message,
        data: error.response?.data,
      },
    };
  },

  activateOrderLaterLoading: (state) => state.orderLater = { ...getDefaultLoadingState() },
  activateOrderLaterLoaded: (state) => state.orderLater = {
    error: undefined,
    status: MutationRequestStatus.SUCCESS,
    data: undefined,
  },
  // Same as activateOrderError: a throw here would leave "activate later" loading and every step-four
  // button disabled, and TV-2145's PAYMENT_PENDING redirect in the error handler would never run.
  activateOrderLaterError: (state, error: AxiosError) => {
    state.orderLater = {
      ...getDefaultErrorState(),
      error: {
        code: error.response?.status,
        message: error.response?.data?.message,
        data: error.response?.data,
      },
    };
  },
};
